import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { Button, Modal } from 'Common/Supplyvue-ui'
import { WorkcentreModalStyleProps } from './WorkcentreModal.types'

export const StyledFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-end',
  position: 'sticky', // fixed typo from "postion"
})

export const ModalActionButton = styled(Button)({
  marginLeft: '20px',
  minWidth: '105px',
})

export const ModalBody = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'readOnly',
})<WorkcentreModalStyleProps>(({ readOnly }) => ({
  minWidth: '700px',
  height: readOnly ? 'calc(50vh + 110px)' : '50vh',
}))

export const SelectAll = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '7px',
  marginBottom: '15px',
})

export const StyledModal = styled(Modal)(({ theme }) => ({
  background: theme.palette.background.default,
}))

export const AccordionsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'readOnly',
})<WorkcentreModalStyleProps>(({ readOnly }) => ({
  overflowY: 'scroll',
  height: readOnly ? '100%' : 'calc(100% - 60px)',
}))

export const Progress = styled(Box)({
  marginRight: '8px',
})
